// extracted by mini-css-extract-plugin
export default {"carousel":"YlB7CP","slide":"PnoykD","active":"EA4F7b"};